import { PrimaryFullScreenSpinner } from "@repo/ui";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { opsHead } from "~/head";

export const Route = createFileRoute("/__auth/currencycloud/rates")({
  head: () => opsHead("Currencycloud Rates"),
  component: () => (
    <Suspense fallback={<PrimaryFullScreenSpinner />}>
      <View />
    </Suspense>
  ),
});

function View() {
  return <div>View rates here</div>;
}
